import axios from "axios";

// Always same-origin and proxied by setupProxy.js (see that file) — the actual backend target
// (REACT_APP_BASE_URL) is read there, server-side, so the browser never makes a direct
// cross-origin request to it (which is what triggered CORS errors when REACT_APP_BASE_URL
// pointed at a remote host like https://user.dev.hitfit.rs).
export const api = axios.create({
  baseURL: "/api",
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("No token found in localStorage!");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
